import React, {useContext, useEffect} from "react";
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

const useBlocker = (confirmExit, when = true) => {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) {
      return;
    }

    const push = navigator.push;

    navigator.push = (...args) => {
      confirmExit(...args);
    };

    return () => {
      navigator.push = push;
    };
  }, [navigator, confirmExit, when]);
}

export default useBlocker;
